<table mat-table [dataSource]="mappedDataSource" id="my-table" matSort>
  <ng-container matColumnDef="itemId">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>
      {{ 'dataManagement.import.id' | transloco }}
    </th>
    <td mat-cell *matCellDef="let element"> {{element.itemId}} </td>
  </ng-container>

  <ng-container matColumnDef="version">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>
      {{ 'dataManagement.import.version' | transloco }}
    </th>
    <td mat-cell *matCellDef="let element"> {{element.version}} </td>
  </ng-container>

  <ng-container matColumnDef="exportingOrganization">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>
      {{ 'dataManagement.import.exportingOrganization' | transloco }}
    </th>
    <td mat-cell *matCellDef="let element"> {{element.exportingOrganization.name}} </td>
  </ng-container>

  <ng-container matColumnDef="packagingTypeName">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>
      {{ 'packagingUnit.packagingUnitType' | transloco }}
    </th>
    <td mat-cell *matCellDef="let element"> {{ element.packagingTypeName }} </td>
  </ng-container>

  <ng-container matColumnDef="brandName">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>
      {{ 'packagingUnit.fields.brandName' | transloco }}
    </th>
    <td mat-cell *matCellDef="let element"> {{ element.brandName }} </td>
  </ng-container>

  <ng-container matColumnDef="productName">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>
      {{ 'packagingUnit.fields.productName' | transloco }}
    </th>
    <td mat-cell *matCellDef="let element"> {{element.productName}} </td>
  </ng-container>

  <ng-container matColumnDef="packagingComponentCategoryName">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>
      {{ 'component.componentType' | transloco }}
    </th>
    <td mat-cell *matCellDef="let element"> {{ element.packagingComponentCategoryName }}
    </td>
  </ng-container>

  <ng-container matColumnDef="packagingComponentSubtypeName">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>
      {{ 'component.componentSpecificType' | transloco }}
    </th>
    <td mat-cell *matCellDef="let element"> {{ element.packagingComponentSubtypeName }} </td>
  </ng-container>

  <ng-container matColumnDef="articleName">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>
      {{ 'component.fields.articleName' | transloco }}
    </th>
    <td mat-cell *matCellDef="let element"> {{ element.articleName }} </td>
  </ng-container>

  <ng-container matColumnDef="articleNumber">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>
      {{ 'component.fields.articleNumber' | transloco }}
    </th>
    <td mat-cell *matCellDef="let element"> {{ element.articleNumber }} </td>
  </ng-container>

  <ng-container *ngIf="!this.isChange" matColumnDef="timestamp">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>
      {{ 'component.fields.exportTimestamp' | transloco }}
    </th>
    <td mat-cell *matCellDef="let element"> {{ element.exportTimestamp | date:'short'}} </td>
  </ng-container>

  <ng-container *ngIf="this.isChange" matColumnDef="timestamp">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>
      {{ 'component.fields.lastModificationTimestamp' | transloco }}
    </th>
    <td mat-cell *matCellDef="let element"> {{ element.lastModificationTimestamp | date:'short'}} </td>
  </ng-container>

  <ng-container matColumnDef="action">
    <th mat-header-cell *matHeaderCellDef>
      <span class="header-text">{{ 'dataManagement.actions' | transloco }}</span>
    </th>
    <td mat-cell *matCellDef="let element">
      <button mat-icon-button type="button" (click)="navigateToCandidate(element)" matTooltip="{{
        (isPackagingSystem ? 'packagingSystem.viewPackagingSystem' :
        isPackagingUnit ? 'packagingUnit.viewPackagingUnit' :
        isComponent ? 'component.viewComponent' :
        isMaterial ? 'material.viewMaterial' : '') | transloco }}" *ngIf="!isChange; else viewChanges">
        <mat-icon>preview</mat-icon>
      </button>
      <ng-template #viewChanges>
        <button mat-icon-button type="button" (click)="navigateToCandidate(element, true)" matTooltip="{{
          (isPackagingSystem ? 'packagingSystem.viewPackagingSystemBeforeChange' :
          isPackagingUnit ? 'packagingUnit.viewPackagingUnitBeforeChange' :
          isComponent ? 'component.viewComponentBeforeChange' :
          isMaterial ? 'material.viewMaterialBeforeChange' : '') | transloco }}">
          <mat-icon>access_time</mat-icon>
        </button>
        <button mat-icon-button type="button" (click)="navigateToCandidate(element, false)" matTooltip="{{
          (isPackagingSystem ? 'packagingSystem.viewPackagingSystemAfterChange' :
          isPackagingUnit ? 'packagingUnit.viewPackagingUnitAfterChange' :
          isComponent ? 'component.viewComponentAfterChange' :
          isMaterial ? 'material.viewMaterialAfterChange' : '') | transloco }}">
          <mat-icon>access_time_filled</mat-icon>
        </button>
      </ng-template>
    </td>
  </ng-container>

  <ng-container matColumnDef="select">
    <th mat-header-cell *matHeaderCellDef>
      <div (click)="$event.stopPropagation()">
        <button mat-button class="filter-button" (click)="selectAll()" type="button">
          <div>{{ 'common.buttons.selectAll' | transloco }} <br> ({{selectedCandidates.length}}
            {{ 'common.text.selected' | transloco }})</div>
        </button>
      </div>
    </th>
    <td mat-cell *matCellDef="let element">
      <mat-checkbox [checked]="isSelectedCandidate(element)" (change)="setSelectedCandidates($event.checked, element)"
        class="margin-checkbox">
      </mat-checkbox>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;" [class.notificationBackground]='row.hasNotification'></tr>

</table>
